/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- ADVANCED SETTINGS - CONFIGURATION PAGE : STYLES --------------- ++++++++++ */
export default {
    advancedconfig: {
    }
};
